import { FC, useCallback, useMemo } from 'react';
import { getIconPrefix } from '../../utils/functions';
import { IconName } from '../../utils/types/icon.type';

interface Props {
    text: string;
    onClick: () => void;
    icon_left?: IconName | string;
    icon_right?: IconName | string;
    style?: 'link' | 'solid' | 'outline' | 'solid-white' | 'table';
    disabled?: boolean;
    isFile?: boolean;
    onFileUploaded?: (file: File) => void;
}

const ButtonComponent: FC<Props> = ({
    text,
    onClick,
    icon_left = '',
    icon_right = '',
    style = 'link',
    disabled = false,
    isFile = false,
    onFileUploaded = () => {
        return;
    },
}) => {
    const handleClick = useCallback(() => {
        if (!disabled) {
            onClick();
        }
    }, [disabled, onClick]);

    const handleChangeUpload = useCallback(
        (event: any) => {
            if (event.target.files && event.target.files.length > 0) {
                onFileUploaded(event.target.files[0]);
            }
        },
        [onFileUploaded],
    );

    const leftIconPrefix = useMemo(() => getIconPrefix(icon_left), [icon_left]);
    const rightIconPrefix = useMemo(() => getIconPrefix(icon_right), [icon_right]);

    return (
        <div className={`buttonComponent ${style} ${disabled ? 'disabled' : ''}`} onClick={handleClick}>
            {isFile ? <input type="file" accept="text/csv" onChange={handleChangeUpload} /> : null}
            {icon_left ? <i className={`${leftIconPrefix}${icon_left}`}></i> : null}
            <span className="text">{text}</span>
            {icon_right ? <i className={`${rightIconPrefix}${icon_right}`}></i> : null}
        </div>
    );
};

export default ButtonComponent;
